
import "../Loader/Loader.css"

export const Loader = () => <div className="flex justify-center items-center min-h-screen"><div className="loader"></div></div>;

